import { usePostHog } from '@posthog/react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const PostHogPageTracker: React.FC = () => {
  const posthog = usePostHog();
  const location = useLocation();

  useEffect(() => {
    posthog?.capture('$pageview', {
      $current_url: window.location.href,
      page: location.pathname,
    });
  }, [location.pathname, posthog]);

  return null;
};
